import React from 'react'
import clsx from 'clsx'
import styles from './MoreMenuItem.module.scss'
import {type TranslationObject} from '@colonist/i18n'
import ChevronIcon from '@static/images/icon_arrow_down.svg'
import OutArrowIcon from '@static/images/icon_arrow_out.svg'
import {T} from '@colonist/ui'

export interface MoreMenuItemProps {
    className?: string
    icon: string
    showNotificationIcon?: boolean
    label: TranslationObject
    rightText?: string
    rightIcon?: 'chevron' | 'outArrow'
    onClick?: () => void
}

const rightIconSrc: Record<string, string> = {
    chevron: ChevronIcon,
    outArrow: OutArrowIcon,
}

export const MoreMenuItem = ({
    className,
    icon,
    showNotificationIcon = false,
    label,
    rightText,
    rightIcon = 'chevron',
    onClick,
}: MoreMenuItemProps) => (
    <div className={clsx(styles.menuItem, className)} onClick={onClick}>
        <div className={styles.iconWrapper}>
            <img className={styles.icon} src={icon} alt="" />
            {showNotificationIcon && <span className={styles.notificationDot} />}
        </div>
        <span className={styles.label}><T id={label} /></span>
        <div className={styles.right}>
            {rightText && <span className={styles.rightText}>{rightText}</span>}
            <img className={clsx(styles.rightIcon, styles[rightIcon])} src={rightIconSrc[rightIcon]} alt="" />
        </div>
    </div>
)
